// extracted by mini-css-extract-plugin
export default {"container":"control-label_container__38-WZ"};